// Mod_Window.ts — the Window modifier (Buildings Set1, §2.5).
//
// A Window is an opening in a wall of the closest ancestor Room. Its world position is projected
// onto the nearest wall segment (§3.6); `sillHeight` is measured from the top of the floor slab.
import {BuildingMaterials} from "./Building/BuildingShared.js";

export class Mod_Window {
	constructor(data?: Partial<Mod_Window>) { Object.assign(this, data); }
	width?: number|n;
	height?: number|n;
	sillHeight?: number|n;        // from the top of the floor slab
	paneDivisionsX?: number|n;
	paneDivisionsY?: number|n;
	materials?: n|BuildingMaterials;
}
